export const getSpace = (spacings: (number | undefined)[], space: number) => {
  const spacing = spacings.find(val => typeof val === 'number');

  if (spacing === undefined) {
    return undefined;
  }

  return spacing * space;
};
